import * as React from 'react';
import { useState, useEffect } from 'react';
import logo from '../img/logo.png'
import logo_w from '../img/logo_w.png'
import Language from '@mui/icons-material/Language';
import Email from '@mui/icons-material/Email';
import Call from '@mui/icons-material/Call';
import MenuIcon from '@mui/icons-material/Menu';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import Typography from '@mui/material/Typography';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Drawer from '@mui/material/Drawer';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';




export default function NavBar({ setLocale, locale, current, setCurrent, navbar }) {

  const handleChange = (event, newValue) => {
    setValueTab(newValue)
    setCurrent(newValue);
  };
  const [menu, setMenu] = useState(false);
  const navbarSort = navbar ? [...navbar].sort((a, b) => a.order - b.order) : [];
  const [valueTab, setValueTab] = useState(0);
  let email = 'email@mail.ru';
  let number = '+7 111 111 11 11';

  const changeLocale = (loc) => {
    setLocale(loc);
    //console.log(locale);
  }


  return (
    <>
      <div className='navbar'>
        <Container>
          <Stack direction='row' justifyContent='flex-end' alignItems='center' mb= "10px"  mt='10px' >
            <Language sx={{ color: '#5281B5', fontSize: '32px', mr: 1 }} ></Language>
            <ButtonGroup variant='outlined' sx={{ borderRadius: '5px' }}>
              <Button sx={{ color: (locale === 'en' ? '#5281B5' : '#ffffff !important'), bgcolor: (locale === 'en' ? '' : '#5281B5') }} onClick={() => changeLocale('ru')}>ru</Button>
              <Button sx={{ color: (locale === 'ru' ? '#5281B5' : '#ffffff !important'), bgcolor: (locale === 'ru' ? '' : '#5281B5') }} onClick={() => changeLocale('en')}>en</Button>
            </ButtonGroup>
            <Stack ml={2}>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Email sx={{ fontSize: '12px', color: '#5281B5' }} />
                <Typography sx={{ color: '#5281B5', fontSize: '12px', ml: "20px" }} component="div">
                  {email}
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Call sx={{fontSize: '12px', color: '#5281B5'}}></Call>
                <Typography sx={{ color: '#5281B5', fontSize: '12px', ml: "20px" }} component="div">
                  {number}
                </Typography>
              </Box>
            </Stack>
          </Stack>
        </Container>
        <Stack direction='row' justifyContent='center' alignItems='flex-end' >
          <Box sx={{ bgcolor: '#E1EEFF', width: '100%', height: '60px', mb: '-65px', ml: '' }} ></Box>
          <Box sx={{ bgcolor: '#2D5B96', width: '100%', height: '60px', mb: '-65px', ml: '' }} ></Box>
        </Stack>
        <Container>
          <div className="trapezoid " ></div>
          <Stack direction='row' justifyContent='end' alignItems='flex-start' >
            <Link
              to="/"
              style={{ display: 'flex', alignItems: 'center', height: "90px"}}
              onClick={() => {
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }}
            >
              <img alt='logo' height='80px' src={logo} className='logo' style={{ cursor: 'pointer' }} />
            </Link>
            {/* Remove underline/decoration from selected tab */}
            <style>
              {`
                .MuiTabs-indicator {
                  display: none !important;
                }
                .Mui-selected {
                  text-decoration: none !important;
                  border-bottom: transparent solid 1px !important;
                  box-shadow: none !important;
                }
              `}
            </style>
            <Tabs
              value={valueTab}
              onChange={handleChange}
              sx={{ ml: '-30px', width: '100%',mt: "35px" }}
              variant="scrollable"
            >
              {navbarSort.length > 0 && navbarSort.map((tab, index) => (
                <Tab
                  key={tab.documentId || index}
                  // component={tab.url.includes('#') ? Link : Link}
                  // to={tab.url.includes('#') ? `${tab.url}` : tab.url}
                  // value={tab.url}
                  component={'a'}
                  href={tab.url}
                  label={tab.name} 
                  value={index}
                  sx={{ fontSize: '12px', color: '#ffffff !important', p: '5px'}}
                  onClick={() => setCurrent(tab.url)}
                />
              ))}
            </Tabs>
          </Stack>
        </Container>
      </div>

      <div className='navbarMobile'>
        <AppBar position="static" sx={{ bgcolor: '#2D5B96' }} className='appBar'>
          <Toolbar className='toolbar' sx={{ mt: '5px', mb: '5px' }}>
          <Link
              to="/"
              style={{ display: 'flex', alignItems: 'center' }}
              onClick={() => {
                const element = document.getElementById("top");
                element.scrollIntoView({ behavior: "smooth", block: "start" });
              }}
            >
              <img alt='logo' height='60px' src={logo_w} ></img>
            </Link>
            
            <IconButton
              size="large"
              edge="start"
              className='menuButton'
              color='#FFF !important'
              aria-label="open drawer"
              sx={{ mr: 2 }}
            >
              <MenuIcon color='#FFF !important' onClick={() => setMenu(!menu)} />
            </IconButton>
          </Toolbar>
          <Drawer open={menu} onClose={() => setMenu(false)} >
            <Box bgcolor='#5281B5' height='100%'>
              <Stack direction='row' m={2}>
                <Language sx={{ color: '#fff ', fontSize: '32px', m: 1 }} ></Language>
                <ButtonGroup variant='outlined'>
                  <Button 
                    sx={{ borderColor: '#fff', color: (locale !== 'en' ? '#5281B5' : '#ffffff !important'), bgcolor: (locale === 'en' ? '' : '#fff') }}
                    onClick={() => {
                      changeLocale('ru');
                      setMenu(false);
                    }}
                  >
                    ru
                  </Button>
                  <Button 
                    sx={{ borderColor: '#fff', color: (locale !== 'ru' ? '#5281B5' : '#ffffff !important'), bgcolor: (locale === 'ru' ? '' : '#fff') }}
                    onClick={() => {
                      changeLocale('en');
                      setMenu(false);
                    }}
                  >
                    en
                  </Button>
                </ButtonGroup>
              </Stack>
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                my={2}
              >
                <Link
                  to="/"
                  style={{ display: 'flex', alignItems: 'center' }}
                  onClick={() => {
                    const element = document.getElementById("top");
                    element.scrollIntoView({ behavior: "smooth", block: "start" });
                    setMenu(false);
                  }}
                >
                  <img alt='logo' height='36px' src={logo_w} />
                </Link>
              </Box>
              <Tabs
                value={valueTab}
                onChange={handleChange}
                sx={{}}
                orientation='vertical'
              >
                {navbar !== null && navbar.map((tab, index) => (
                  <Tab key={index}                  
                    component={'a'}
                    href={tab.url}
                    label={tab.name} 
                    value={index}
                    sx={{ fontSize: '10px', color: '#fff !important', height: '30px' }} 
                    onClick={() => {
                      setCurrent(tab.url);
                      setMenu(false);
                    }}
                 />))}
              </Tabs>
              <Stack direction='row' justifyContent='start' m={2}>
                <Email sx={{ color: '#fff' }}></Email>
                <Typography sx={{ color: '#fff', fontSize: '16px' }} component="div">
                  {email}
                </Typography>
              </Stack>
              <Stack direction='row' justifyContent='start'>
                <Call sx={{ color: '#fff', ml: 2 }}></Call>
                <Typography sx={{ color: '#fff', fontSize: '16px' }} component="div">
                  {number}
                </Typography>
              </Stack>
            </Box>
          </Drawer>
        </AppBar>
      </div>
    </>

  );
}